import React from 'react';
import type { OverviewItem } from '../model';
import { ConfirmPanel } from './ConfirmPanel';

interface Props {
  test: OverviewItem;
  busy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteTestPanel: React.FC<Props> = ({ test, busy, onConfirm, onCancel }) => (
  <ConfirmPanel
    danger
    title={`Удалить тест «${test.title}» навсегда?`}
    text={`Вместе с тестом удалятся его вопросы (${test.questions_count}), назначения (${test.assignments.total}) и все результаты прохождений. Восстановить их нельзя.`}
    confirmLabel="Удалить навсегда"
    cancelLabel="Отмена"
    busy={busy}
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
);
